import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import PropertyCard from "../components/PropertyCard";
import { api, errMsg } from "../lib/api";
import { useLang } from "../context/LangContext";
import { Building2, User2, Phone, MapPin } from "lucide-react";

export default function Profile() {
  const { id } = useParams();
  const { t } = useLang();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/users/${id}`).then((r) => setData(r.data)).catch((e) => setErr(errMsg(e, "Error")));
  }, [id]);

  if (err) return <div><Header /><div className="pt-32 text-center text-slate-500">{err}</div></div>;
  if (!data) return <div><Header /><div className="pt-32 text-center text-slate-500">{t("loading")}</div></div>;

  const { user, listings, count } = data;
  const isAgency = user.role === "agency";

  return (
    <div className="min-h-screen">
      <Header />
      <div className="pt-24 max-w-7xl mx-auto px-5 md:px-10 pb-20">
        <div className="bg-white rounded-2xl border border-slate-200 p-8 mt-6 flex flex-col md:flex-row md:items-center gap-6" data-testid="profile-card">
          <div className={`w-20 h-20 rounded-2xl flex items-center justify-center ${isAgency ? "bg-[#F59E0B]/10" : "bg-[#1B8F5A]/10"}`}>
            {isAgency ? <Building2 size={32} className="text-[#F59E0B]" /> : <User2 size={32} className="text-[#1B8F5A]" />}
          </div>
          <div className="flex-1">
            <div className="flex items-center gap-3 flex-wrap">
              <h1 className="text-3xl md:text-4xl font-bold text-[#111827]" data-testid="profile-name">{user.name}</h1>
              <span className={`text-xs uppercase tracking-wider font-bold px-2.5 py-1 rounded ${isAgency ? "bg-[#F59E0B]/10 text-[#92400E]" : "bg-[#1B8F5A]/10 text-[#1B8F5A]"}`}>
                {isAgency ? t("agency") : t("privateOwner")}
              </span>
            </div>
            {user.phone && (
              <div className="flex items-center gap-2 text-slate-600 mt-2">
                <Phone size={14} /><span className="text-sm">{user.phone}</span>
              </div>
            )}
            <div className="text-sm text-slate-500 mt-2">{count} {count > 1 ? t("results") : t("result")}</div>
          </div>
        </div>

        <h2 className="text-xl font-bold text-[#111827] mt-12 mb-6">{t("listings")}</h2>
        {listings.length === 0 ? (
          <div className="bg-white rounded-2xl border border-slate-200 p-16 text-center text-slate-500">{t("noListingsYet")}</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="profile-listings">
            {listings.map((p) => <PropertyCard key={p.id} item={p} />)}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
